<template>
  <div :class="langFlag ?'enPage':''">
    <div :class="moveFlag?'tarnsf':''">
      <div class="iheader">
        <h1 class="ihed_h1">
          <img src="~@/assets/image/svg/Top Logo_black.svg"
               class="logo_img"
               @click="toHome()"
               v-show="!moveFlag" />
          <img src="~@/assets/image/svg/Top Logo_black.svg"
               class="logo_img"
               @click="toHome()"
               v-show="moveFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>
    <div class="hdplace"></div>
    <div class="imageList">
      <div class="jourCon">
        <div class="jourCon_hd">
          <div class="back"
               @click="back()">
            <i class="back_ico"></i>
            <span class="back_na">{{langFlag ?'back':'回文章' }}</span>
          </div>
          <!-- <img :src="newsJson.pic"
               class="timage" /> -->
          <van-image Lazyload
                     show-loading
                     show-error
                     fit="cover"
                     :src="newsJson.pic"
                     class="timage"></van-image>
        </div>
        <div class="jourCon_tit">
          <div class="jourCon_tit_p1 fontS">{{newsJson.title}}</div>
          <div class="jourCon_tit_p2">{{newsJson.ptime}}</div>
        </div>
        <div class="jourCon_in">
          <p class="jour_p1 fontS">{{newsJson.title}}</p>
          <p class="jour_p2">{{newsJson.author}}</p>
          <div v-html="newsJson.desp"></div>
          <!-- <p class="jour_p3">随着时代的变迁、社会的发展，人们对待美的观念也逐渐发生着变化。由于现代主义建筑革命深刻地改变了传统
            的建筑美学观念，建筑风格多元化逐渐形成，因此更应该从更深层次的角度对建筑去进行思考和研究。</p>
          <p class="jour_p3">本文从建筑符号学理论为研究背景，主要剖析安藤忠雄的建筑构成手法，从安藤忠雄的建筑代表作品中总结其
            在建筑构成中所体现的建筑符号和在符号学领域下的构成手法，进而分析安藤忠雄在建筑设计过程中的理念体
            现和形式符号的应用过程，总结其建筑构成手法的特征。</p>
          <div class="jour_im">
            <img src="~@/assets/images/timage1.jpg"
                 class="timage_img" />
            <img src="~@/assets/images/timage2.jpg"
                 class="timage_img" />
          </div> -->
          <!-- swier begin -->
          <!-- <div class="jourSwi">
            <div class="swiper-container jour_swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="~@/assets/images/sw1.jpg"
                       class="timage_img" />
                </div>
                <div class="swiper-slide">
                  <img src="~@/assets/images/sw1.jpg"
                       class="timage_img" />
                </div>
                <div class="swiper-slide">
                  <img src="~@/assets/images/sw1.jpg"
                       class="timage_img" />
                </div>
              </div> -->
          <!-- 如果需要分页器 -->
          <!-- <div class="swiper-pagination"></div> -->

          <!-- 如果需要导航按钮 -->
          <!-- <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div> -->
          <!-- swier end -->
          <!-- <p class="jour_p4">如今，建筑符号学研究者利用横纵两条坐标轴线的形式来探讨组合关系和聚合关系（如图1）。两轴理论的核心横
            轴上的语言单位以依序邻接在一起，纵轴可以“对等”或“等价”。</p>
          <p class="jour_p3">随着时代的变迁、社会的发展，人们对待美的观念也逐渐发生着变化。由于现代主义建筑革命深刻地改变了传统
            的建筑美学观念，建筑风格多元化逐渐形成，因此更应该从更深层次的角度对建筑去进行思考和研究。</p>
          <p class="jour_p3">本文从建筑符号学理论为研究背景，主要剖析安藤忠雄的建筑构成手法，从安藤忠雄的建筑代表作品中总结其在
            建筑构成中所体现的建筑符号和在符号学领域下的构成手法，进而分析安藤忠雄在建筑设计过程中的理念体现
            和形式符号的应用过程，总结其建筑构成手法的特征。</p>
          <div class="jour_in clearfix">
            <div class="jour_in_rg right">
              <img src="~@/assets/images/timage3.jpg"
                   class="timage_img" />
              <p class="jour_in_p">多功能木桩书柜, 丹麦 哥本哈根</p>
            </div>
          </div>
          <p class="jour_p3">
            平面构成有着两种性质的意义，一方面有着理性的图形分割意义，另一方面有着情感意义。而安藤忠雄的平面构成
            以图底互换的构成手法居多，其中出色的运用是光之教堂的建筑符号学。从理性图形角度分析，之前的教堂表现十
            字架这一形式符号，大多以墙为底，以十字架为图，突出十字架的图案性（如图2）。而安藤忠雄的思维更加具有创造
            性，他将十字架符号在建筑外立面掏空，阳光照进来形成了以建筑外部的光为底，以墙面镂空为图的十字架图案，以
            墙的背光面的黑暗反衬十字架的光明（如图3）。从情感角度分析，这种构成手法既表达了十字架形式符号的装饰意
            义，更重要的是，利用光感来突出象征十字架的宗教内涵。这不再流于简单的平面思维，而是将平面构成手法与三维
            环境中的光、墙、影相结合，图底关系拓展到三维空间，使图与底之间有了纵深感。不仅仅如此，安藤忠雄的光之教堂
            十字架还与他之前的水之教堂十字架相呼应，水之教堂室外空间的巨大十字架正是光之教堂镂空的图案。这种图底
            关系的巧妙运用与建筑之间的时空呼应，增添了安藤忠雄宗教题材建筑的建筑符号学上的文脉感和建筑哲学上的
            统一性。
          </p>
          <div class="jouer_out">
            <img src="~@/assets/images/timage_pic.jpg"
                 class="timage_pic" />
            <p class="jour_in_p">石灰岩在拱门上的运用, 丹麦 哥本哈根</p>
          </div>
          <p class="jour_p3">利用两轴法分析安藤忠雄的平面构成手法，在隐喻方面，安藤忠雄和其他设计师是一致的，通过十字架符号语言比
            喻基督教堂的神圣，而在转喻方面，安藤忠雄比其他设计师高明许多，他不用实体的物质来表现十字架，而是通过三
            维的关系和光感来转喻基督教堂的神圣。</p>
 -->
        </div>
        <gotop></gotop>
      </div>
      <!-- footer -->
      <foot @contact="contact"></foot>
      <!-- 菜单 -->
      <transition name="slide-fade">
        <menuPage v-show="muneFlag"
                  :muneFlag="muneFlag"
                  :muneIndex="muneIndex"
                  @closeMu="closeMu"></menuPage>
      </transition>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import menuPage from '@/components/menu.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { Lazyload } from 'vant'
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
Vue.use(Lazyload)
export default {
  data() {
    return {
      bgFlag: false,
      muneFlag: false,
      muneIndex: 2,
      mySwiper: null,
      moveFlag: false,
      newsJson: {},
      newsId: '',
      contTit: '日志详情',
    }
  },
  components: { foot, gotop, menuPage },
  mounted() {
    this.newsId = this.$route.query.newsId || ''
    this.newsInfo()
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()
    })

    let that = this

    // 滚动条滚动
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.newsInfo()
    },
  },
  methods: {
    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 0
    },
    closeMu() {
      this.muneFlag = false
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scrollTop < 10) {
        this.moveFlag = false
      } else {
        this.moveFlag = true
      }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'index',
        // query: {
        //   type: type,
        // },
      })
    },
    back() {
      this.$router.back()
    },
    // 获取日志详情
    newsInfo() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'newsInfo',
        that.$qs.stringify({
          type: type,
          id: that.newsId,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.newsJson = response.data
            document.title = response.data.title
            that.$nextTick(function () {
              that.mySwiper = new Swiper('.jour_swiper', {
                observer: true,
                observeParents: true,
                speed: 1800,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                // autoplay: {
                //   delay: 3000,
                //   disableOnInteraction: false,
                // },
                // loop: true,
                // pagination: {
                //   el: '.swiper-pagination',
                // },
                navigation: {
                  nextEl: '.jour_swiper .swiper-button-next',
                  prevEl: '.jour_swiper .swiper-button-prev',
                },
              })
            })
          }
        })
        .catch(function (error) {})
    },
  },
}
</script>






// WEBPACK FOOTER //
// src/pages/journal.vue